/* COMPONENTS */
import { Button, Grid } from "@material-ui/core";
import { Table, TableCell, TableHead, TableRow } from "@material-ui/core";
import { SummaryTable, exportToPDF } from "components/Table/SummaryTable";
import { useEffect, useState } from "react";
import {
  blankFilters,
  detailedFeesColumns,
  getSummaryHeader,
  summaryRowHeader,
} from "./tablesUtils/Sales";

import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import LoaderBar from "components/LoaderBar/LoaderBar";
import CustomMUIDataTable from "components/MUIDatatable/CustomMUIDataTable";
import PageTitle from "components/PageTitle/PageTitle";
import SelectionForm from "components/SelectionForm/AuditSelectionForm";
/*  FUNCTIONS AND DATA */
import { format } from "date-fns";
import { dbGet } from "utils/DBFetchers";
import { getRoleName } from "utils/roleNameGetter";
/* STYLES */
import useStyles from "./styles";

import { WITH_WALLET_TYPE } from "./tablesUtils/Sales";
import { el } from "date-fns/locale";
import { set } from "lodash";

const allPrograms = [
  { id: 1, name: "Receta solidaria" },
  { id: 2, name: "Solo mujer" },
  { id: 3, name: "GES" },
  { id: 4, name: "Mi Salcobrand" },
  { id: 5, name: "Crónicos Ahumada" },
];

const gesProgram = [{ id: 3, name: "GES" }];

export default function SalesPage() {
  var [isLoading, setIsLoading] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  var classes = useStyles();
  const [groupFilter, setGroupFilter] = useState("");
  const [walletFilter, setWalletFilter] = useState("");
  const [newFormattedTableData, setNewFormattedTableData] = useState([]);
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [colorColumnIndex, setColorColumnIndex] = useState(-1);
  const [groupColumnIndex, setGroupColumnIndex] = useState(-1);
  const [walletColumnIndex, setWalletColumnIndex] = useState(-1);
  const [filters, setFilters] = useState(blankFilters);
  const [summaryData, setSummaryData] = useState([]);
  const [summary, setSummary] = useState({});
  const [canDownloadPDF, setCanDownloadPDF] = useState(false);
  const [distributorFees, setDistributorFees] = useState([]);
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const [allDistributors, setAllDistributors] = useState([]);
  const [dataRequestId, setDataRequestId] = useState(0);
  const [downloadFilename, setDownloadFilename] = useState(null);

  // Color variables
  let errorCellColor = "251, 201, 199"; // red
  let warningCellColor = "255, 255, 187"; // yellow
  let okCellColor = "194, 241, 190"; // green
  // Important to set the right color for the cells

  // Groups //
  const ALL_GROUPS = "Total";

  // Formats price with dot for thousands and comma for decimals
  const formatNumber = (value) => {
    return value
      ? Intl.NumberFormat("es-AR").format(Math.round(value * 100) / 100)
      : 0;
  };

  // Checks if the filters are valid
  const validFilters = () => {
    let validDistributor = filters.distributor ? true : false;
    let validProgram = filters.program ? true : false;

    if (!validDistributor) {
      snackbarOpen("error", "El campo de cadena está vacio");
    }
    if (!validProgram) {
      snackbarOpen("error", "El campo del programa está vacio");
    }

    return validDistributor && validProgram;
  };

  // Export to PDF setup
  const handleExportToPDF = (props) => {
    // API requiers header to be a list of lists or dics.
    let headers = [];
    props.header.map((value) => {
      headers.push(value.title);
    });
    props.header = [];
    props.header.push(headers);
    props.name = `Reporte de Ventas `;
    if (groupFilter) {
      props.name += `${groupFilter} `;
    }
    props.name += `${props.date.data}`;
    exportToPDF(props);
  };

  // Create and save the summary data table
  const createSummaryData = (data, distributorFees) => {
    // INFORMADO === LOS QUE ESTÁN BIEN + LOS ERRORS + LOS WARNINGS
    // CALCULADO === LOS QUE ESTÁN BIEN + LOS WARNINGS
    // CORREGIDOS === LOS WARNINGS
    let newSummaryData = [
      // Each array is a row on the summary table
      [
        // 'Total liquidación' - informed
        formatNumber(data.total_transactions),
        formatNumber(data.total_informed_units),
        formatNumber(data.total_informed_discount),
        "-",
        "-",
      ],
      [
        // 'Descuentos con errores' - errors
        formatNumber(data.total_error_transactions),
        formatNumber(data.total_error_units),
        formatNumber(-data.total_error_discount),
        "-",
        "-",
      ],
      [
        // 'Descuentos corregidos' - warnings
        formatNumber(data.total_warning_transactions),
        formatNumber(data.total_warning_units),
        formatNumber(data.total_warning_discount),
        "-",
        "-",
      ],
      [
        // 'Diferencia': final - informed
        formatNumber(data.total_transactions_valid - data.total_transactions),
        formatNumber(data.total_calculated_units - data.total_informed_units),
        formatNumber(
          data.total_calculated_discount - data.total_informed_discount,
        ),
        "-",
        "-",
      ],
      [
        // 'A pagar' - final
        formatNumber(data.total_transactions_valid),
        formatNumber(data.total_calculated_units),
        formatNumber(data.total_calculated_discount),
        formatNumber(data.total_transaction_fee),
        data.total_administration_fee
          ? formatNumber(data.total_administration_fee)
          : 0,
      ],
    ];

    summaryRowHeader.map((value, index) => {
      newSummaryData[index].unshift(value);
    });

    setSummaryData(newSummaryData);
  };


  const updateProgress = (id) => {
    dbGet(`request_checker/status?id=${id}`)
      .then((response) => {
        if (response.status === "Completed") {
          setIsLoading(false);
          setIsLoadingButton(false);
          if (response.length === 0 || response.data.length === 0) {
            setSummaryData([]);
            setCanDownloadPDF(false);
            return;
          }

          let distributorFees = [
            response.data.fees.unitary_administration_fee,
            response.data.fees.unitary_transaction_fee,
          ];
          createSummaryData(
            response.data.fees.summary[ALL_GROUPS],
            distributorFees,
          );

          let formatted_data = response.data.formatted_data;
          let columns_order = response.data.columns_order;

          if (formatted_data && formatted_data.length > 0) {
            const keys = columns_order ? columns_order : Object.keys(formatted_data[0]);

            const colorIndex = keys.indexOf("Color celda");
            setColorColumnIndex(colorIndex);

            const groupIndex = keys.indexOf("Grupo");
            setGroupColumnIndex(groupIndex);

            const walletIndex = keys.indexOf("Billetera");
            setWalletColumnIndex(walletIndex);

            const newColumns = keys.map((key, index) => {
              // 1. Detectamos si la columna pertenece a los grupos especiales
              const isInfor = key.startsWith("infor ");
              const isCalc = key.startsWith("calc ");
              const isGrouped = isInfor || isCalc;

              // 2. Definimos qué texto va arriba y qué texto va abajo
              let topLabel = null;
              let bottomLabel = key;

              if (isInfor) {
                bottomLabel = key.replace("infor ", ""); // "Total", "ExLab", etc.
                // Solo si es "infor Total" ponemos el título, si no, espacio vacío
                topLabel = (key === "infor Total") ? "Informado" : "\u00A0";
              } else if (isCalc) {
                bottomLabel = key.replace("calc ", "");
                // Solo si es "calc Total" ponemos el título, si no, espacio vacío
                topLabel = (key === "calc Total") ? "Calculado" : "\u00A0";
              }

              return {
                name: key,
                label: key,
                options: {
                  filter: key === "Grupo" || key === "Billetera",
                  display: key === "Color celda" ? 'excluded' : true,

                  // rowSpan: 2 es vital para que las columnas normales (Fecha, ID) 
                  // se centren verticalmente respecto a estas columnas dobles.
                  setCellHeaderProps: () => ({
                    rowSpan: 2,
                    style: {
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      backgroundColor: "#FFF",
                      zIndex: 101,
                    },
                  }),

                  customHeadLabelRender: (columnMeta) => {
                    // Si es una columna normal (no empieza con infor/calc), devolvemos el texto simple
                    if (!isGrouped) {
                      return key;
                    }

                    // Estilos para la mini-tabla
                    const headerStyle = {
                      whiteSpace: "nowrap",
                      position: "sticky",
                      top: 0,
                      zIndex: 100,
                      stickyHeader: true,
                    };

                    return (
                      <Table style={{ display: "flex", alignItems: "center", backgroundColor: "transparent" }}>
                        <TableHead>
                          {/* --- FILA SUPERIOR --- */}
                          <TableRow style={{ ...headerStyle }}>
                            <TableCell
                              style={{
                                padding: "4px",
                                textAlign: "center",
                                borderBottom: "none",
                                fontWeight: "bold",
                                // Si es un espacio vacío (\u00A0), esto asegura que mantenga la altura
                                minHeight: "20px"
                              }}
                            >
                              {topLabel}
                            </TableCell>
                          </TableRow>

                          {/* --- FILA INFERIOR --- */}
                          <TableRow style={{ ...headerStyle, zIndex: 1 }}>
                            <TableCell style={{ textAlign: "center", borderBottom: "none" }}>
                              {bottomLabel}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                    );
                  },

                  setCellProps: () => ({
                    style: {
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      backgroundColor: `rgba(255, 255, 255,${setCellTransparency(index, key)})`,
                    },
                  }),
                }
              };
            });

            setDynamicColumns(newColumns);
            setNewFormattedTableData(formatted_data);
          }

          // Save all the groups data for later use
          setSummary(response.data.fees.summary);
          setCanDownloadPDF(true);
          setIsLoading(false);
        } else if (!response.error_status && response.status !== "Failure") {
          setTimeout(updateProgress.bind(null, id), 2000);
        } else {
          snackbarOpen(
            "error",
            response.error_message
              ? response.error_message.description_es
              : "Error cargando la tabla",
          );
          setIsLoading(false);
        }
      })
      .catch((error) => {
        snackbarOpen(
          "error",
          error.error_message
            ? error.error_message.description_es
            : "Error cargando la tabla",
        );
        setIsLoading(false);
      });
  };

  const setCellTransparency = (index, key) => {
    if (key.includes("calc")) {
      return 0.7;
    } else if (key.includes("infor")) {
      return 0.5;
    } else {
      return index % 2 === 0 ? 0.7 : 0.5
    }
  };

  // Get data
  const handleApplyFilters = () => {
    if (!validFilters()) {
      return;
    }
    setNewFormattedTableData([]);
    setDynamicColumns([]);
    const periodFormated = format(filters.period, "yyyyMM");
    const period = `&period=${periodFormated}`;
    const distributorId = `${filters.distributor ? `&distributor_id=${filters.distributor}` : ""
      }`;
    const programId = `&program_id=${filters.program}`;
    const status = `&status=${filters.status}`;
    const importID = `&import_id=${filters.importID}`;
    const errors = `&error_ids=${filters.observations.join(",")}`;
    const zoneId = `${filters.zone ? `&zone_id=${filters.zone}` : ""}`;
    const auditType =
      filters.program === 1
        ? `&audit_type=${filters.type}`
        : filters.program === 5
          ? "&audit_type=cronicos_ahumada"
          : "&audit_type=traditionals";

    // Formateo para enviar los keys de with_wallet_type en lugar de los labels
    const withWalletTypeKey =
      Object.entries(WITH_WALLET_TYPE).find(
        ([, label]) => label === filters.with_wallet_type,
      )?.[0] ?? "WITHOUT_WALLET"; // fallback si no matchea nada
    const withWalletType = filters.program === 1 ? `&with_wallet_type=${withWalletTypeKey}` : "";

    setIsLoading(true);
    dbGet(
      `audit/sales?${period}${programId}${distributorId}${importID}${status}${errors}${zoneId}${auditType}${withWalletType}`,
    )
      .then((response) => {
        setDataRequestId(response.id);
        setDownloadFilename(`Ventas ${filters.period} ${getProgramNameById(filters.program)} ${getDistributorNameById(filters.distributor)}.xlsx`);
        setTimeout(updateProgress.bind(null, response.id), 3000);
      })
      .catch((error) => {
        if (error.response) {
          snackbarOpen(
            "error",
            error.response.data
              ? error.response.data.description_es
              : "Error cargando la tabla",
          );
          setNewFormattedTableData([]);
          setDynamicColumns([]);
          setDownloadFilename("empty_file");
          setIsLoading(false);
        }
      });
  };

  const getDistributors = () => {
    dbGet("distributors").then((data) => {
      setAllDistributors(data);
    });
  };

  useEffect(() => {
    getDistributors();
  }, []);

  const getDistributorNameById = (id) => {
    let distributor = allDistributors.find(
      (distributor) => distributor.id === id,
    );
    return distributor ? distributor.name : "";
  };

  const getProgramNameById = (id) => {
    let program = allPrograms.find((program) => program.id === id);
    return program ? program.name : "";
  };

  // Update the summary with the selected group
  useEffect(() => {
    if (summary && Object.keys(summary).length) {
      if (!groupFilter) {
        createSummaryData(summary[ALL_GROUPS]);
      } else {
        createSummaryData(summary[groupFilter]);
      }
    }
  }, [groupFilter]);

  useEffect(() => {
    if (filters.period && filters.distributor) {
      const periodFormated = format(filters.period, "yyyyMM");
      const period = `period=${periodFormated}`;
      const distributor = `distributor_id=${filters.distributor}`;
      const programId = `&program_id=${filters.program}`;
      dbGet(`distributors/historical?${period}&${distributor}&${programId}`)
        .then((data) => {
          setDistributorFees(data);
        })
        .catch((err) => {
          setDistributorFees([]);
          snackbarOpen(
            "error",
            "Error cargando los descuentos de distribuidor",
          );
        });
    }
  }, [filters.distributor, filters.period, filters.program]);

  const newDefaultRowProps = (row) => {
    if (row[colorColumnIndex] === "red") {
      return {
        style: { backgroundColor: `rgb(${errorCellColor})` },
      };
    } else if (row[colorColumnIndex] === "yellow") {
      return {
        style: {
          backgroundColor: `rgb(${warningCellColor})`
        },
      };
    } else
      return {
        style: { backgroundColor: `rgb(${okCellColor})` },
      };
  };

  useEffect(() => {
    setSummaryData([]);
    setCanDownloadPDF(false);
  }, [filters]);

  const onDownload = () => {
    dbGet(`audit/sales/download?id=${dataRequestId}&desired_filename=${downloadFilename}`)
      .then((data) => {
        const fileUrl = data?.data;
        if (fileUrl) {
          window.open(fileUrl, "_blank");
        } else {
          snackbarOpen("error", "No se recibió un archivo para descargar");
        }
      })
      .catch((err) => {
        snackbarOpen("error", "Error al descargar el archivo",);
      });
  };

  return (
    <>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <div>
        <PageTitle
          title="Ventas"
        // button={
        //   <img src={logo} alt="logo" className={classes.logotypeImage} />
        // }
        />
      </div>
      <Grid
        style={{ display: "flex", margin: 0 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
        spacing={4}
        xs={12}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={6}
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginLeft: "-30px",
          }}
        >
          <Grid
            container
            xs={12}
            md={12}
            lg={12}
            layout={"row"}
            spacing={"1"}
            style={{ border: "1px" }}
          >
            <SelectionForm
              isLoading={isLoading}
              isLoadingButton={isLoadingButton}
              setIsLoading={setIsLoadingButton}
              setFilters={setFilters}
              filters={filters}
              applyFunction={handleApplyFilters}
              programs={getRoleName() === "ges" ? gesProgram : allPrograms}
              independents={getRoleName() === "ges" ? false : undefined}
              sales
            />
          </Grid>
        </Grid>
        <Grid container item xs={12} sm={12} md={12} lg={12} xl={6}>
          <Grid item xs={12} style={{ border: "1px" }}>
            <SummaryTable
              title="Ventas"
              columns={getSummaryHeader(filters.program)}
              rows={summaryData}
              detailedFeesColumns={detailedFeesColumns}
              detailedFeesRows={distributorFees}
            />
          </Grid>
          <Grid item xs={12} className={classes.alignCenter}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleExportToPDF({
                  title: "Ventas",
                  header: getSummaryHeader(filters.program),
                  data: summaryData,
                  date: filters.period,
                });
              }}
              style={{ marginTop: "5%", marginBottom: "5px" }}
              disabled={!canDownloadPDF}
            >
              Descargar PDF
            </Button>
          </Grid>
        </Grid>
        {isLoading ? (
          <LoaderBar />
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {dynamicColumns.length > 0 && (
                <CustomMUIDataTable
                  title="Ventas"
                  data={newFormattedTableData} // Pasamos formatted_data directamente (Array de Objetos)
                  // exportData={rawExportData} // Data cruda para exportar (si la lógica interna lo soporta)
                  columns={dynamicColumns} // Pasamos las columnas generadas
                  setFilter={{
                    [groupColumnIndex]: setGroupFilter,
                    [walletColumnIndex]: setWalletFilter
                  }}
                  titleDownload={`Ventas ${filters.period} ${getProgramNameById(
                    filters.program
                  )} ${getDistributorNameById(filters.distributor)}`}
                  setRowProps={newDefaultRowProps}
                  customDownloadCallback={onDownload}
                />
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
}
